<template>
  <div class="container">
    <div class="m-2" v-if="order_type === 'walk_in'">
      <img src="@/assets/images/red.png" alt="" /> &nbsp; {{ $t("busy") }} &nbsp;&nbsp;&nbsp;
      <img src="@/assets/images/white.png" alt="" />  &nbsp;{{ $t("available") }} -
      {{ $t("double click to unselect table") }}
    </div>
    <loading v-if="loading_table"></loading>
    <div style="display: flex" class="mb-3" v-if="loading_table == false">
      <div class="restaurant_table">
        <template v-for="(table, index) in tables">
          <button
            class="btn btn-table pointer"
            @click="select_table(table)"
            :key="index"
            :class="{
              disable_table: table.status != 'available',
              table_tmp_selected: tmp_selected.id === table.id,
            }"
          >
            <span> <v-icon color="white">mdi-table-furniture</v-icon></span>
            <p>{{ table.name }}</p>
          </button>
        </template>
      </div>
      <div class="right_action" v-if="meta_table.total > meta.limit">
        <button
          @click="next()"
          class="btn btn-close pointer m-1"
          style="height: 80px"
        >
          <span>
            <v-icon size="30">mdi-arrow-right-bold-circle-outline</v-icon></span
          >
        </button>
        <button
          @click="previous()"
          class="btn btn-close pointer m-1"
          style="height: 80px"
        >
          <span>
            <v-icon size="30">mdi-arrow-left-bold-circle-outline</v-icon></span
          >
        </button>
      </div>
    </div> 
  </div>
</template>
<style>
.right_action {
  width: 106px;
}

.disable_table {
  background: #ff0000;
  color: white;
  border: 0;
}

.disable_table .v-icon.v-icon {
  color: white !important;
}

.table_tmp_selected {
    background: #007bff;
}
.restaurant_table {
    text-align: center;
}
</style>
<script>
import store from "@/store";
import Swal from "sweetalert2";
export default {
  name: "BaseTable",
  props: {
    status: String,
    value: Object,
  },
  data: () => ({
    tmp_selected: {},
    meta: {
      limit: "100",
      page: 1,
      search: "",
      restaurant_id: 0,
    },
  }),
  computed: {
    restaurant_selected() {
      return store.getters["restaurant/restaurant"];
    },
    tables() {
      return store.getters["location/parent_location"];
    },
    meta_table() {
      return store.getters["location/meta_table"];
    },
    loading_table() {
      return store.getters["location/loading"];
    },
    order_type() {
      return store.getters["order/order_type"];
    },
    table_status() {
      return store.getters["order/table_status"];
    },
  },
  mounted() {
    this.getTables();
    this.tmp_selected = this.value;
  },
  methods: {
    async select_table(table) {
      if (table.status != "available") {
        await store.dispatch("order/getTableStatus", { "table_id": table.id, "type_id": this.restaurant_selected.id}); 
        if(!this.table_status.sale){ 
          Swal.fire({ 
            showCancelButton: true,
            confirmButtonText: `Open Table`, 
            title: table.name + ' ' + this.$i18n.t("is not available."),
            text:  this.$i18n.t("Do you want to open table!"),
          }).then((result) => { 
            if (result.isConfirmed) { 
                this.$store.dispatch("location/forceFreeTable",  {table_id: table.id}); 
 
                this.tmp_selected = table;
                this.$emit("selected", false);
                return this.$emit("input", table);
            }
          });
          return;
        }

        Swal.fire({ 
          showCancelButton: true,
          confirmButtonText: `Open Sale`, 
          title: this.$i18n.t("Opp..."),
          text:
            this.$i18n.t("There is pending order on id") +
            ": " +
            this.table_status.sale.id +
            " !",
        }).then((result) => { 
          if (result.isConfirmed) { 
              this.$store.dispatch("order/modifyOrder",  this.table_status.sale); 
              this.$emit("open_sale", true);
              this.$emit("selected", false);
              return this.$emit("input", table);
          }
        });
        return;
      }
      if (table.id === this.tmp_selected.id) {
        this.tmp_selected = {};
        return this.$emit("input", {});
      }
      this.tmp_selected = table;
      this.$emit("selected", false);
      return this.$emit("input", table);
    },

    async getTables() {
      if (!this.restaurant_selected) return;
      this.meta.restaurant_id = this.restaurant_selected.id;
      if (this.order_type === "walk_in") {
        this.meta.type = "TABLE";
      }
      if (this.order_type === "hotel_guest") {
        this.meta.type = "ROOM";
      }
      await store.dispatch("location/get_locations", this.meta);
    },
    async next() {
      this.meta.page++;
      if (this.meta.page > this.meta_table.last_page) {
        this.meta.page = this.meta_table.last_page;
        return;
      }
      await this.getTables();
    },
    async previous() {
      this.meta.page--;
      if (this.meta.page < 1) {
        this.meta.page = 1;
        return;
      }
      await this.getTables();
    },
  },
  destroyed() {
    this.tmp_selected = {};
  },
};
</script>